// Import utilities
import { itemsObject } from '../../../common/utilities';
import shouldBeSortable from './should-be-sortable';

/**
 * Adds a property to all actions to easily recognize that they have actions
 *
 * @return {undefined}
 */
const flagActionsSortable = () => {
	// Get recipe actions
	const actions = itemsObject( 'get', {
		filter: { itemType: 'action' },
	} );

	// Add the default flag to all actions
	// The default flag is false
	for ( const actionID in actions ) {
		// Check if it has the meta that only scheduled/delayed actions have
		UncannyAutomator.recipe.items[ actionID ].isSortable = shouldBeSortable( { actionID: actionID } );
	}
};

export default flagActionsSortable;
